import { useQuery } from '@tanstack/react-query';
import { fetchUserDealers, fetchUserProducts, fetchUserColleagues } from '../services/security';

// each hook fetches specific user-related options
// need to get the userId from context or auth state in a real implementation
export const useDealersQuery = (userId: string) => {
    return useQuery({
        queryKey: ['user-dealers'],
        queryFn: () => fetchUserDealers(userId),
        staleTime: 0,
        gcTime: 0,
        refetchOnMount: 'always',
        retry: 2,
        enabled: true,
    });
};

export const useProductsQuery = (userId: string) => {
    return useQuery({
        queryKey: ['user-products'],
        queryFn: () => fetchUserProducts(userId),
        staleTime: 0,
        gcTime: 0,
        refetchOnMount: 'always',
        retry: 2,
        enabled: true,
    });
};

export const useColleaguesQuery = (userId: string, options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: ['user-colleagues'],
        queryFn: () => fetchUserColleagues(userId),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        retry: 2,
        enabled: Boolean(userId) && (options?.enabled ?? true),
    });
};
